import { CheckCircle2 } from 'lucide-react';
import { formatUsd } from '@ach/shared';

/**
 * The confirmation.
 *
 * States plainly that no money has moved yet. That is the single most common
 * thing a customer misunderstands at this point, and getting it wrong produces
 * either a duplicate payment by another route or a phone call.
 */
export function Done({ reference, amountCents }: { reference: string; amountCents: number }) {
  return (
    <div className="card mx-auto max-w-lg p-6 text-center">
      <CheckCircle2 className="mx-auto h-12 w-12 text-emerald-600" aria-hidden />

      <h1 className="mt-4 text-lg font-semibold text-slate-900">Thank you — we have your details</h1>

      <p className="mt-2 text-slate-600">
        Your authorization for <strong>{formatUsd(amountCents)}</strong> has been recorded.
      </p>

      <div className="mt-5 rounded-lg bg-slate-50 p-4">
        <p className="text-xs uppercase tracking-wide text-slate-500">Reference</p>
        <p className="mt-0.5 font-account text-xl font-bold text-slate-900">{reference}</p>
      </div>

      <div className="mt-5 space-y-2 text-left text-sm text-slate-600">
        <p>
          <strong className="text-slate-900">Nothing has been taken from your account yet.</strong>{' '}
          We will schedule the debit with our bank, and it usually posts to your account within one
          to three banking days.
        </p>
        <p>
          You will see it on your statement as a debit from Gold Star Printing. There is nothing
          further you need to do.
        </p>
      </div>

      <p className="mt-5 border-t border-slate-100 pt-4 text-xs text-slate-500">
        Questions about this payment? Call 574-555-0100 and quote reference {reference}.
      </p>
    </div>
  );
}
